<template>
    <div
      class="bet-view fav-type"
      :class="
        (hasBottomBar === undefined ||
          hasBottomBar == true ||
          hasBottomBar == 'true') &&
        $breakpoint.smAndDown
          ? 'mb-10'
          : 'mb-0'
      "
    >
      <v-container class="max-style">
        <v-row>
          <v-col
            cols="12"
            md="3"
            lg="2"
            :class="{
              'px-0': $breakpoint.lgAndUp,
              'pt-2 pr-0': $breakpoint.mdAndUp,
              'px-0 pt-0 pb-0': $breakpoint.smAndDown
            }"
          >
            <sportsbook-category
              :is-empty="isEmpty"
              :orientation="$breakpoint.smAndDown ? 'horizontal' : 'vertical'"
            ></sportsbook-category>
            <!-- <favorites v-if="$auth.loggedIn && $breakpoint.mdAndUp"></favorites> -->
          </v-col>
          <v-col
            cols="12"
            :class="{
              'col-md-9 col-lg-10 py-0': !$auth.loggedIn,
              'pr-0': $breakpoint.lgAndUp,
              'pt-2': $breakpoint.mdAndUp,
              'px-0 py-0': $breakpoint.smAndDown,
              'col-md-6 col-lg-7': $auth.loggedIn,
              'dual-tabs--desktop-new': !$breakpoint.smAndDown
            }"
          >
            <!-- Live and Upcoming tabs - Desktop -->
            <v-tabs
              v-if="$breakpoint.mdAndUp"
              v-model="tab"
              height="52"
              class="pt-0"
              hide-slider
              @change="handleTabChange"
            >
              <v-tab>
                <span v-if="liveMarkets.image" class="pr-2 pt-2"
                  ><img contain :src="liveMarkets.image" width="20px" />
                </span>
                <v-icon class="pr-2" size="20"> {{ liveMarkets.icon }}</v-icon>
                <v-badge
                  color="primary"
                  :content="liveMarkets.fixtures.length"
                  :value="liveMarkets.fixtures.length"
                  offset-y="7"
                  offset-x="-2"
                >
                  {{ liveMarkets.tab }}
                </v-badge>
              </v-tab>
              <v-tab>
                <span v-if="upcomingMarkets.image" class="pr-2 pt-2"
                  ><img contain :src="upcomingMarkets.image" width="20px" />
                </span>
                <v-icon class="pr-2" size="20">
                  {{ upcomingMarkets.icon }}</v-icon
                >
                <v-badge
                  color="primary"
                  :content="upcomingMarkets.fixtures.length"
                  :value="upcomingMarkets.fixtures.length"
                  offset-y="7"
                  offset-x="-2"
                >
                  {{ upcomingMarkets.tab }}
                </v-badge>
              </v-tab>
              <v-tab v-if="leagues">
                <span v-if="leagues.image" class="pr-2 pt-2"
                  ><img contain :src="leagues.image" width="20px" />
                </span>
                <v-icon class="pr-2" size="20"> {{ leagues.icon }}</v-icon>
                {{ leagues.tab }}
              </v-tab>
            </v-tabs>
            <v-col
              v-if="$breakpoint.smAndDown"
              cols="12"
              class="d-flex px-0 pb-0 pt-1"
            >
              <!-- live game and upcoming tabs -->
              <!-- <div class="col-3"></div> -->
              <div class="col-12 pa-0 dual-tabs--mobile">
                <v-tabs
                  v-model="tab"
                  tile
                  hide-slider
                  :grow="$breakpoint.smAndDown"
                  centered
                  height="60"
                  :class="{
                    'dark-theme': $vuetify.theme.dark
                  }"
                  :slider-color="
                                    domainUrl ? 'primary' : 'superBlue'
                                "
                  @change="handleTabChange"
                >
                  <!-- class="leaguetabs" -->
                  <v-tab>
                    <span v-if="liveMarkets.image" class="pr-2 pt-2">
                      <img contain :src="liveMarkets.image" width="20px" />
                    </span>
                    <v-icon class="pr-2" size="20">{{ liveMarkets.icon }}</v-icon>
                    <v-badge
                      color="primary"
                      :content="liveMarkets.fixtures.length"
                      :value="liveMarkets.fixtures.length"
                      offset-y="4"
                    >
                      {{ liveMarkets.tab }}
                    </v-badge>
                  </v-tab>
                  <v-tab>
                    <span v-if="upcomingMarkets.image" class="pr-2 pt-2">
                      <img contain :src="upcomingMarkets.image" width="20px" />
                    </span>
                    <v-icon class="pr-2" size="20">{{
                      upcomingMarkets.icon
                    }}</v-icon>
                    <v-badge
                      color="primary"
                      :content="upcomingMarkets.fixtures.length"
                      :value="upcomingMarkets.fixtures.length"
                      offset-y="4"
                    >
                      {{ upcomingMarkets.tab }}
                    </v-badge>
                  </v-tab>
                  <v-tab v-if="leagues">
                    <span v-if="leagues.image" class="pr-2 pt-2">
                      <img contain :src="leagues.image" width="20px" />
                    </span>
                    <v-icon class="pr-2" size="20"> {{ leagues.icon }}</v-icon>
                    {{ leagues.tab }}
                  </v-tab>
                </v-tabs>
              </div>
              <div
                class="col-12 mx-auto pa-0 bg-bar below-600"
                style="border-bottom: 1px solid #333 !important; height: 52px"
              >
                <v-tabs
                  id="leaguetabs-mobile"
                  v-model="tab"
                  tile
                  :grow="$breakpoint.smAndDown"
                  centered
                  hide-slider
                  class="leaguetabs-mobile flex-column"
                  :class="{
                    'dark-theme': $vuetify.theme.dark
                  }"
                >
                  <div
                    v-for="(filter, i) in filterGroups"
                    :key="i"
                    class="d-flex align-items-center justify-content-center filter-tabs mx-0"
                  >
                    <v-tab
                      v-for="(market, i) in markets.slice(
                        i * itemsPerRow,
                        (i + 1) * itemsPerRow
                      )"
                      :key="i"
                      class="caption px-2"
                      :class="{ market }"
                    >
                      <v-icon class="pr-1"> {{ market.icon }}</v-icon>
                      {{ market.tab }}
                    </v-tab>
                  </div>
                </v-tabs>
              </div>
            </v-col>
            <!-- live game and upcoming tabs -->
            <!-- <v-tabs v-model="tab" tile centered height="35">
              <v-tab v-for="(market, i) in markets" :key="i" class="caption pa-0">
                {{ market.tab }}
              </v-tab>
            </v-tabs> -->
            <!-- <SportsFilter class="mb-2" /> -->
  
            <v-skeleton-loader
              tile
              dense
              :loading="loading"
              type="list-item-two-line"
              :class="{
                'white-theme': !$vuetify.theme.dark,
                'dark-theme': $vuetify.theme.dark
              }"
            >
              <v-tabs-items
                v-model="tab"
                :class="{
                  sportsbook: $breakpoint.mdAndUp,
                  'px-2 pt-3': $breakpoint.smAndDown,
                  'dark-theme': $vuetify.theme.dark
                }"
              >
                <!-- <hourse-racing
                  v-if="$route.params.category === 'horse-racing' && tab === 0"
                /> -->
  
                <v-tab-item>
                  <template
                    v-if="
                      !['horse-racing', 'greyhound-racing'].includes(
                        $route.params.category
                      )
                    "
                  >
                    <v-expansion-panels
                      v-if="liveMarkets.fixtures"
                      :value="openAll(liveMarkets.fixtures)"
                      flat
                      tile
                      multiple
                    >
                      <v-expansion-panel
                        v-for="fixture in liveMarkets.fixtures"
                        :key="fixture._id"
                        class="mt-2 mb-2 border-radius"
                        :class="{
                          'shadow-light': !$vuetify.theme.dark
                        }"
                        style="
                          border-bottom-right-radius: 1rem;
                          border-bottom-left-radius: 1rem;
                        "
                      >
                        <div>
                          <v-expansion-panel-header
                            class="caption pa-0"
                            hide-actions
                          >
                            <template
                              v-if="
                                fixture &&
                                fixture.competitionId &&
                                fixture.competitionId._id &&
                                fixture.parentCategory &&
                                fixture.eventId
                              "
                              #default="{ open }"
                            >
                              <primary-bar
                                :title="getTitle(liveMarkets.tab, fixture)"
                                :subtitle="fixture.eventName"
                                :name="fixture.name"
                                :live="fixture.inPlayStatus === 'Open'"
                                :open="open"
                                favorite-btn
                                :markets="fixture"
                                :isthree-et="fixture.threeETId"
                                :is-favorite="fixture.isFavourite"
                                :market-id="fixture.betfairId"
                                :tv="fixture.videoUrl"
                                :video="
                                  fixture.videoUrlStatus === 'true' ||
                                  fixture.videoUrlStatus === 'On'
                                "
                                :to="
                                  fixture.eventId
                                    ? `/sportsbook/${categoryGame}/${fixture.competitionId._id}/${fixture.parentCategory}/${fixture.eventId}?tabIdx=${tab}`
                                    : `/sportsbook/${categoryGame}/${fixture.competitionId._id}/${fixture.parentCategory}?tabIdx=${tab}`
                                "
                              />
                            </template>
                            <template
                              v-else-if="
                                fixture && fixture.gameName === 'UOFGame'
                              "
                              #default="{ open }"
                            >
                              <primary-bar
                                :title="getTitle(liveMarkets.tab, fixture)"
                                :subtitle="fixture.eventName"
                                :name="fixture.gameName"
                                :live="fixture.status === 'live'"
                                :open="open"
                                :markets="fixture"
                                :isthree-et="fixture.threeETId"
                                :market-id="fixture.betfairId"
                                :tv="fixture.videoUrl"
                                :video="
                                  fixture.videoUrlStatus === 'true' ||
                                  fixture.videoUrlStatus === 'On'
                                "
                                :to="`/sportsbook/${categoryGame}/UOFGame/${fixture.eventId}`"
                              />
                            </template>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content
                            v-if="
                              fixture &&
                              !fixture.artemisMatchOddsData &&
                              fixture.competitionId &&
                              fixture.competitionId._id &&
                              fixture.parentCategory &&
                              fixture.eventId
                            "
                            class="pa-0"
                          >
                            <item-odds
                              v-if="
                                !$auth.user ||
                                !(
                                  fixture &&
                                  fixture.eventType &&
                                  fixture.eventType.name === 'Cricket' &&
                                  $auth.user &&
                                  !$auth.user.matchOdds &&
                                  fixture.name &&
                                  fixture.name.toLowerCase() === 'match odds'
                                )
                              "
                              :key="fixture.betfairId"
                              :market="fixture"
                              :runners="
                                fixture &&
                                fixture.runners &&
                                Array.isArray(fixture.runners) &&
                                fixture.runners.length <= 0
                                  ? [{ name: fixture.eventName }]
                                  : fixture.runners
                              "
                              :market-id="fixture.betfairId"
                              :matchodds-bookmaker="isMatchoddsBookmaker"
                              :to="
                                fixture.eventId
                                  ? `/sportsbook/${categoryGame}/${fixture.competitionId._id}/${fixture.parentCategory}/${fixture.eventId}`
                                  : `/sportsbook/${categoryGame}/${fixture.competitionId._id}/${fixture.parentCategory}`
                              "
                              :max-commission="maxBookmakerCommission"
                              class="listOdds"
                            >
                            </item-odds>
                          </v-expansion-panel-content>
                          <v-expansion-panel-content
                            v-else-if="
                              fixture &&
                              fixture.artemisMatchOddsData &&
                              fixture.competitionId &&
                              fixture.competitionId._id &&
                              fixture.parentCategory &&
                              fixture.eventId
                            "
                            class="pa-0"
                          >
                            <item-odds-artemis
                              v-if="
                                !$auth.user ||
                                !(
                                  fixture &&
                                  fixture.eventType &&
                                  fixture.eventType.name === 'Cricket' &&
                                  $auth.user &&
                                  !$auth.user.matchOdds &&
                                  fixture.name &&
                                  fixture.name.toLowerCase() === 'match odds'
                                )
                              "
                              :key="fixture.betfairId"
                              :market="fixture"
                              :runners="
                                fixture &&
                                fixture.runners &&
                                Array.isArray(fixture.runners) &&
                                fixture.runners.length <= 0
                                  ? [{ name: fixture.eventName }]
                                  : fixture.runners
                              "
                              :market-id="fixture.betfairId"
                              :matchodds-bookmaker="isMatchoddsBookmaker"
                              :to="
                                fixture.eventId
                                  ? `/sportsbook/${categoryGame}/${fixture.competitionId._id}/${fixture.parentCategory}/${fixture.eventId}`
                                  : `/sportsbook/${categoryGame}/${fixture.competitionId._id}/${fixture.parentCategory}`
                              "
                              :max-commission="maxBookmakerCommission"
                              class="listOdds"
                            >
                            </item-odds-artemis>
                          </v-expansion-panel-content>
                          <v-expansion-panel-content
                            v-else-if="fixture && fixture.gameName === 'UOFGame'"
                            class="pa-0"
                          >
                            <non-bet-fair-item-odds
                              :key="fixture.eventId"
                              :market="fixture"
                              :runners="
                                fixture &&
                                fixture.markets &&
                                Array.isArray(fixture.markets) &&
                                fixture.markets.length <= 0
                                  ? [{ name: fixture.eventName }]
                                  : fixture.markets
                              "
                              :to="`/sportsbook/${categoryGame}/UOFGame/${fixture.eventId}`"
                            >
                            </non-bet-fair-item-odds>
                          </v-expansion-panel-content>
                        </div>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </template>
  
                  <template v-else>
                    <!-- HR/GHR -->
                    <v-expansion-panels
                      v-if="liveMarkets.fixtures"
                      :value="openAll(liveMarkets.fixtures)"
                      flat
                      tile
                      multiple
                    >
                      <v-expansion-panel
                        v-for="fixture in liveMarkets.fixtures"
                        :key="fixture._id"
                        class="mt-2 mb-2 border-radius"
                        :class="{
                          'shadow-light': !$vuetify.theme.dark
                        }"
                        style="
                          border-bottom-right-radius: 1rem;
                          border-bottom-left-radius: 1rem;
                        "
                      >
                        <div>
                          <v-expansion-panel-header
                            class="caption pa-0"
                            hide-actions
                          >
                            <template
                              v-if="
                                fixture &&
                                fixture.competitionId &&
                                fixture.competitionId._id &&
                                fixture.parentCategory &&
                                fixture.eventId
                              "
                              #default="{ open }"
                            >
                              <primary-bar
                                :title="getTitle(liveMarkets.tab, fixture)"
                                :subtitle="fixture.eventName"
                                :name="fixture.name"
                                :live="fixture.inPlayStatus === 'Open'"
                                :open="open"
                                favorite-btn
                                :markets="fixture"
                                :isthree-et="fixture.threeETId"
                                :is-favorite="fixture.isFavourite"
                                :market-id="fixture.betfairId"
                                :tv="fixture.videoUrl"
                                :video="
                                  fixture.videoUrlStatus === 'true' ||
                                  fixture.videoUrlStatus === 'On'
                                "
                                :to="
                                  fixture.eventId
                                    ? `/sportsbook/${toKebabCase(categoryGame)}/${
                                        fixture.competitionId._id
                                      }/${fixture.parentCategory}/${
                                        fixture.eventId
                                      }?name=${fixture.name}?tabIdx=${tab}`
                                    : `/sportsbook/${toKebabCase(categoryGame)}/${
                                        fixture.competitionId._id
                                      }/${fixture.parentCategory}?name=${
                                        fixture.name
                                      }?tabIdx=${tab}`
                                "
                                :side-text="['Back']"
                              />
                            </template>
                            <template
                              v-else-if="
                                fixture && fixture.gameName === 'UOFGame'
                              "
                              #default="{ open }"
                            >
                              <primary-bar
                                :title="getTitle(liveMarkets.tab, fixture)"
                                :subtitle="fixture.eventName"
                                :name="fixture.gameName"
                                :live="fixture.status === 'live'"
                                :open="open"
                                :markets="fixture"
                                :isthree-et="fixture.threeETId"
                                :market-id="fixture.betfairId"
                                :tv="fixture.videoUrl"
                                :video="
                                  fixture.videoUrlStatus === 'true' ||
                                  fixture.videoUrlStatus === 'On'
                                "
                                :to="`/sportsbook/${toKebabCase(
                                  categoryGame
                                )}/UOFGame/${fixture.eventId}?name=${
                                  fixture.name
                                }`"
                              />
                            </template>
                          </v-expansion-panel-header>
  
                          <v-expansion-panel-content
                            v-if="
                              fixture &&
                              fixture.competitionId &&
                              fixture.competitionId._id &&
                              fixture.parentCategory &&
                              fixture.eventId
                            "
                            class="pa-0"
                          >
                            <item-odds-racing
                              v-if="
                                !$auth.user ||
                                !(
                                  fixture &&
                                  fixture.eventType &&
                                  fixture.eventType.name === 'Cricket' &&
                                  $auth.user &&
                                  !$auth.user.matchOdds &&
                                  fixture.name &&
                                  fixture.name.toLowerCase() === 'match odds'
                                )
                              "
                              :key="fixture.betfairId"
                              :market="fixture"
                              :runners="
                                fixture &&
                                fixture.runners &&
                                Array.isArray(fixture.runners) &&
                                fixture.runners.length <= 0
                                  ? [{ name: fixture.eventName }]
                                  : fixture.runners
                              "
                              :market-id="fixture.betfairId"
                              :matchodds-bookmaker="isMatchoddsBookmaker"
                              :max-commission="maxBookmakerCommission"
                              :isInplayLive="false"
                              class="listOdds"
                            >
                            </item-odds-racing>
                          </v-expansion-panel-content>
                          <v-expansion-panel-content
                            v-else-if="fixture && fixture.gameName === 'UOFGame'"
                            class="pa-0"
                          >
                            <non-bet-fair-item-odds
                              :key="fixture.eventId"
                              :market="fixture"
                              :runners="
                                fixture &&
                                fixture.markets &&
                                Array.isArray(fixture.markets) &&
                                fixture.markets.length <= 0
                                  ? [{ name: fixture.eventName }]
                                  : fixture.markets
                              "
                              :to="`/sportsbook/${toKebabCase(
                                categoryGame
                              )}/UOFGame/${fixture.eventId}?name=${fixture.name}`"
                            >
                            </non-bet-fair-item-odds>
                          </v-expansion-panel-content>
                        </div>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </template>
  
                  <div v-if="!loading && liveMarkets?.fixtures?.length === 0">
                    <!-- <v-alert dense> -->
                    <v-img
                      :src="require('@/assets/playicons/nomatches.svg')"
                      :lazy-src="require('@/assets/playicons/nomatches.svg')"
                      max-width="250"
                      alt=""
                      style="margin: 0 auto"
                    ></v-img>
                    <!-- Currently no live matches available -->
                    <!-- </v-alert> -->
                  </div>
                </v-tab-item>
  
                <v-tab-item>
                  <template
                    v-if="
                      !['horse-racing', 'greyhound-racing'].includes(
                        $route.params.category
                      )
                    "
                  >
                    <v-expansion-panels
                      v-if="upcomingMarkets.fixtures"
                      :value="openAll(upcomingMarkets.fixtures)"
                      flat
                      tile
                      multiple
                    >
                      <v-expansion-panel
                        v-for="fixture in upcomingMarkets.fixtures"
                        :key="fixture._id"
                        class="mt-2 mb-2 border-radius"
                        :class="{
                          'shadow-light': !$vuetify.theme.dark
                        }"
                        style="
                          border-bottom-right-radius: 1rem;
                          border-bottom-left-radius: 1rem;
                        "
                      >
                        <div>
                          <v-expansion-panel-header
                            class="caption pa-0"
                            hide-actions
                          >
                            <template
                              v-if="
                                fixture &&
                                fixture.competitionId &&
                                fixture.competitionId._id &&
                                fixture.parentCategory &&
                                fixture.eventId
                              "
                              #default="{ open }"
                            >
                              <primary-bar
                                :title="getTitle(upcomingMarkets.tab, fixture)"
                                :subtitle="fixture.eventName"
                                :name="fixture.name"
                                :live="fixture.inPlayStatus === 'Open'"
                                :open="open"
                                favorite-btn
                                :markets="fixture"
                                :isthree-et="fixture.threeETId"
                                :is-favorite="fixture.isFavourite"
                                :market-id="fixture.betfairId"
                                :tv="fixture.videoUrl"
                                :video="
                                  fixture.videoUrlStatus === 'true' ||
                                  fixture.videoUrlStatus === 'On'
                                "
                                :to="
                                  fixture.eventId
                                    ? `/sportsbook/${categoryGame}/${fixture.competitionId._id}/${fixture.parentCategory}/${fixture.eventId}?tabIdx=${tab}`
                                    : `/sportsbook/${categoryGame}/${fixture.competitionId._id}/${fixture.parentCategory}?tabIdx=${tab}`
                                "
                              />
                            </template>
                            <template
                              v-else-if="
                                fixture && fixture.gameName === 'UOFGame'
                              "
                              #default="{ open }"
                            >
                              <primary-bar
                                :title="getTitle(upcomingMarkets.tab, fixture)"
                                :subtitle="fixture.eventName"
                                :name="fixture.gameName"
                                :live="fixture.status === 'live'"
                                :open="open"
                                :markets="fixture"
                                :isthree-et="fixture.threeETId"
                                :market-id="fixture.betfairId"
                                :tv="fixture.videoUrl"
                                :video="
                                  fixture.videoUrlStatus === 'true' ||
                                  fixture.videoUrlStatus === 'On'
                                "
                                :to="`/sportsbook/${categoryGame}/UOFGame/${fixture.eventId}`"
                              />
                            </template>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content
                            v-if="
                              fixture &&
                              !fixture.artemisMatchOddsData &&
                              fixture.competitionId &&
                              fixture.competitionId._id &&
                              fixture.parentCategory &&
                              fixture.eventId
                            "
                            class="pa-0"
                          >
                            <item-odds
                              v-if="
                                !$auth.user ||
                                !(
                                  fixture &&
                                  fixture.eventType &&
                                  fixture.eventType.name === 'Cricket' &&
                                  $auth.user &&
                                  !$auth.user.matchOdds &&
                                  fixture.name &&
                                  fixture.name.toLowerCase() === 'match odds'
                                )
                              "
                              :key="fixture.betfairId"
                              :market="fixture"
                              :runners="
                                fixture &&
                                fixture.runners &&
                                Array.isArray(fixture.runners) &&
                                fixture.runners.length <= 0
                                  ? [{ name: fixture.eventName }]
                                  : fixture.runners
                              "
                              :market-id="fixture.betfairId"
                              :matchodds-bookmaker="isMatchoddsBookmaker"
                              :to="
                                fixture.eventId
                                  ? `/sportsbook/${categoryGame}/${fixture.competitionId._id}/${fixture.parentCategory}/${fixture.eventId}`
                                  : `/sportsbook/${categoryGame}/${fixture.competitionId._id}/${fixture.parentCategory}`
                              "
                              :max-commission="maxBookmakerCommission"
                              class="listOdds"
                            >
                            </item-odds>
                          </v-expansion-panel-content>
                          <v-expansion-panel-content
                            v-else-if="
                              fixture &&
                              fixture.artemisMatchOddsData &&
                              fixture.competitionId &&
                              fixture.competitionId._id &&
                              fixture.parentCategory &&
                              fixture.eventId
                            "
                            class="pa-0"
                          >
                            <item-odds-artemis
                              v-if="
                                !$auth.user ||
                                !(
                                  fixture &&
                                  fixture.eventType &&
                                  fixture.eventType.name === 'Cricket' &&
                                  $auth.user &&
                                  !$auth.user.matchOdds &&
                                  fixture.name &&
                                  fixture.name.toLowerCase() === 'match odds'
                                )
                              "
                              :key="fixture.betfairId"
                              :market="fixture"
                              :runners="
                                fixture &&
                                fixture.runners &&
                                Array.isArray(fixture.runners) &&
                                fixture.runners.length <= 0
                                  ? [{ name: fixture.eventName }]
                                  : fixture.runners
                              "
                              :market-id="fixture.betfairId"
                              :matchodds-bookmaker="isMatchoddsBookmaker"
                              :to="
                                fixture.eventId
                                  ? `/sportsbook/${categoryGame}/${fixture.competitionId._id}/${fixture.parentCategory}/${fixture.eventId}`
                                  : `/sportsbook/${categoryGame}/${fixture.competitionId._id}/${fixture.parentCategory}`
                              "
                              :max-commission="maxBookmakerCommission"
                              class="listOdds"
                            >
                            </item-odds-artemis>
                          </v-expansion-panel-content>
                          <v-expansion-panel-content
                            v-else-if="fixture && fixture.gameName === 'UOFGame'"
                            class="pa-0"
                          >
                            <non-bet-fair-item-odds
                              :key="fixture.eventId"
                              :market="fixture"
                              :runners="
                                fixture &&
                                fixture.markets &&
                                Array.isArray(fixture.markets) &&
                                fixture.markets.length <= 0
                                  ? [{ name: fixture.eventName }]
                                  : fixture.markets
                              "
                              :to="`/sportsbook/${categoryGame}/UOFGame/${fixture.eventId}`"
                            >
                            </non-bet-fair-item-odds>
                          </v-expansion-panel-content>
                        </div>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </template>
                  <template v-else>
                    <upcoming-racing
                      title="Upcoming Races"
                      v-if="upcomingMarkets?.fixtures?.length > 0"
                      :matches="upcomingMarkets.fixtures"
                    />
                  </template>
                  <div v-if="!loading && upcomingMarkets?.fixtures?.length === 0">
                    <!-- <v-alert dense> -->
                    <v-img
                      :src="require('@/assets/playicons/nomatches.svg')"
                      :lazy-src="require('@/assets/playicons/nomatches.svg')"
                      max-width="250"
                      style="margin: 0 auto"
                      alt=""
                    ></v-img>
                    <!-- Currently no live matches available -->
                    <!-- </v-alert> -->
                  </div>
                </v-tab-item>
  
                <v-tab-item>
                  <competitions
                    v-if="compitions?.length && !loading"
                    :compitions="compitions"
                    :color="$vuetify.theme.dark ? 'white' : 'black'"
                    :tab-idx="tab"
                  ></competitions>
                  <div v-if="!compitions?.length && !loading">
                    <v-alert dense border="left" outlined type="warning">
                      Currently no Leagues available
                    </v-alert>
                  </div>
                </v-tab-item>
  
                <!-- <div
                    v-if="
                      !loading &&
                      market.tab === '1 H' &&
                      market.fixtures.length === 0
                    "
                  >
                    <v-img
                      :src="require('@/assets/playicons/nomatches.svg')"
                      :lazy-src="require('@/assets/playicons/nomatches.svg')"
                      max-width="250"
                      style="margin: 0 auto"
                      alt=""
                    ></v-img>
                    Currently no matches available in 1 Hours
                  </div> -->
                <!-- <div
                    v-if="
                      !loading &&
                      market.tab === '3 H' &&
                      market.fixtures.length === 0
                    "
                  >
                    <v-img
                      :src="require('@/assets/playicons/nomatches.svg')"
                      :lazy-src="require('@/assets/playicons/nomatches.svg')"
                      max-width="250"
                      style="margin: 0 auto"
                      alt=""
                    ></v-img>
                    Currently no matches available in 3 Hours
                  </div> -->
                <!-- <div
                    v-if="
                      !loading &&
                      market.tab === '12 H' &&
                      market.fixtures.length === 0
                    "
                  >
                    <v-img
                      :src="require('@/assets/playicons/nomatches.svg')"
                      :lazy-src="require('@/assets/playicons/nomatches.svg')"
                      max-width="250"
                      style="margin: 0 auto"
                      alt=""
                    ></v-img>
                    Currently no matches available in 12 Hours
                  </div> -->
                <!-- <recent-matches
                    v-if="market.tab === 'Results'"
                  ></recent-matches> -->
              </v-tabs-items>
            </v-skeleton-loader>
          </v-col>
          <v-col
            v-if="$auth.loggedIn && $breakpoint.mdAndUp"
            md="3"
            class="hits-sticky"
            :class="{
              'matches-overflow pt-1 pl-0': $breakpoint.mdAndUp,
              'pr-0 pl-3': $breakpoint.lgAndUp
            }"
          >
            <desktop-rightbar></desktop-rightbar>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </template>
  
  <script>
  import { mapState } from 'vuex'
  import upperFirst from 'lodash/upperFirst'
  import SportsbookCategory from '@/components/sections/SportsbookCategory'
  import NonBetFairItemOdds from '@/components/nonBetFair/NonBetFairItemOdds'
  import ItemOdds from '@/components/ItemOdds'
  import ItemOddsArtemis from '@/components/ItemOddsArtemis'
  import ItemOddsRacing from '@/components/ItemOddsRacing.vue'
  import PrimaryBar from '@/components/toolbars/PrimaryBar'
  import socket from '@/plugins/socket.client'
  import Competitions from '@/components/Competitions'
  // import Favorites from '@/components/Favorites'
  // import RecentMatches from '@/components/RecentMatches'
  import DesktopRightbar from '@/components/DesktopRightbar'
  import UpcomingRacing from '~/components/UpcomingRacing.vue'
  // import SportsFilter from '~/components/layouts/SportsFilter'
  
  export default {
    components: {
      SportsbookCategory,
      ItemOdds,
      ItemOddsArtemis,
      PrimaryBar,
      Competitions,
      //   Favorites,
      DesktopRightbar,
      // RecentMatches,
      NonBetFairItemOdds,
      UpcomingRacing,
      ItemOddsRacing
      // SportsFilter
    },
    middleware: ['validateUser'],
    data() {
      return {
        domainUrl: process.env.THEME_BASIC === "true" ? 1 : 0,
        tabs: 0,
        tab: 0,
        itemsPerRow: 4,
        maxBookmakerCommission: undefined,
        categoryGame: 'Cricket',
        refresh: true,
        isMatchoddsBookmaker: false,
        hasBottomBar: process.env.BOTTOM_BAR,
        title: "",
        description: "",
        horseCategory: null,
        invalidBets: [],
        betfairEventID: []
      }
    },
    head() {
        return {
            title: this.title,
            meta: [
                {
                    hid: "description",
                    name: "description",
                    content: this.description
                }
                // {
                //     name: "robots",
                //     content: "noindex"
                // }
            ]
        }
    },
    computed: {
      gameName() {
        return this.categoryGame
      },
      filterGroups() {
        return Array.from(
          Array(Math.ceil(this.markets.length / this.itemsPerRow)).keys()
        )
      },
      // liveFixtures() {
      //   return (
      //     this.markets[0]?.fixtures.length > 0 &&
      //     this.markets[0]?.fixtures?.filter(
      //       (fixture) => fixture?.status === 'live'
      //     )
      //   )
      // },
      // upcomingRaces() {
      //   return this.markets[0]?.fixtures?.filter(
      //     (fixture) => fixture?.status === 'upcoming'
      //   )
      // },
      ...mapState({
        markets: (state) => [
          state.sportsbook.liveData,
          state.sportsbook.upcomingData,
          state.sportsbook.leagues
        ],
        liveMarkets: (state) => state.sportsbook.liveData,
        upcomingMarkets: (state) => state.sportsbook.upcomingData,
        leagues: (state) => state.sportsbook.leagues,
        isEmpty: (state) => state.sportsbook.isEmpty,
        liveMatchIds: (state) => state.sportsbook.liveMatchIds,
        upcomingMatchIds: (state) => state.sportsbook.upcomingMatchIds,
        loading: (state) => state.sportsbook.loading,
        selectedBetfairId: (state) => state.placeBet.runner,
        compitions: (state) => state.sportsbookCategory.competionData,
        games: (state) => state.sportsbookCategory.data
      }),
      artemisCallTest() {
        return this.$store.state.sportsbook.artemisCall
      }
    },
    watch: {
      artemisCallTest(value) {
        if (value) {
          if (this.tab === 0) {
            this.checkArtemisDataAvailable(this.liveMarkets?.fixtures)
            this.$store.commit('sportsbook/setArtemisFunction', false)
          } else {
            this.checkArtemisDataAvailable(this.upcomingMarkets?.fixtures, true)
            this.$store.commit('sportsbook/setArtemisFunction', false)
          }
        }
      }
    },
    // watch: {
    // markets() {
    // const tempData = JSON.parse(JSON.stringify(this.newMarkets))
    // if (this.markets && this.markets[0] && this.markets[0].fixtures) {
    //   this.newMarkets = [...this.markets[0].fixtures]
    // }
    // if (
    //   tempData &&
    //   tempData[0] &&
    //   tempData[0].name &&
    //   tempData[0].name === 'Cricket' &&
    //   tempData[0].markets &&
    //   tempData[0].markets.length &&
    //   this.newMarkets &&
    //   this.newMarkets[0] &&
    //   this.newMarkets[0].name &&
    //   this.newMarkets[0].name === 'Cricket' &&
    //   this.newMarkets[0].markets &&
    //   this.newMarkets[0].markets.length
    // ) {
    //   for (let i = 0; i < tempData[0].markets.length; i++) {
    //     if (tempData[0].markets[i].artemisMatchOddsData) {
    //       this.newMarkets[0].markets[i].artemisMatchOddsData =
    //         tempData[0].markets[i].artemisMatchOddsData
    //     }
    //   }
    // }
    // if (!showHrAndGhr && this.newMarkets && this.newMarkets.length) {
    //   this.newMarkets = this.newMarkets.filter(
    //     (m) => !['Horse Racing', 'Greyhound Racing'].includes(m.name)
    //   )
    // }
    // this.checkArtemisDataAvailable()
    // }
    // },
    async created() {
      // Clear all markets data on page load - Start
      this.$store.commit('sportsbook/set_data', { matchData: [] })
      this.$store.commit('sportsbook/set_data', {
        matchData: [],
        upComing: true
      })
      this.$store.commit('sportsbook/set_matchIds', { data: [] })
      this.$store.commit('sportsbook/set_matchIds', { data: [], upComing: true })
      // Clear all markets data on page load - End
  
      if (
        !['horse-racing', 'greyhound-racing'].includes(
          this.$route.params.category
        )
      ) {
        this.categoryGame = upperFirst(this.$route.params.category)
        this.$store.commit('sportsbook/set_leagues', true)
      } else {
        this.categoryGame = this.fromKebabToNormalCase(
          this.$route.params.category
        )
        this.$store.commit('sportsbook/set_leagues', false)
      }
  
      // Tab Selection Persistence logic - Start
      this.clearOtherGameTabLocalStorage()
      const prevSelectedTab = localStorage.getItem(`activeTab_${this.gameName}`)
      if (prevSelectedTab !== undefined) {
        this.tab = +prevSelectedTab
      } else {
        this.tab = 0 // 'Live' tab
      }
      localStorage.removeItem(`activeTab_${this.gameName}`)
      // Tab Selection Persistence logic - End
  
      let userId
      if (this.$auth?.loggedIn) {
        userId = this.$auth?.user?._id
      }
      await this.handleTabChange('init')
      // Uncomment after fix
      socket.commonSocket.on(
        'marketEnable_' + upperFirst(this.categoryGame),
        async (data) => {
          try {
            const payload = {
              game: upperFirst(this.categoryGame),
              userId,
              loading: false,
              socketData: data,
              gameName: this.$route.params.subCategory
            }
            if (this.tab === 0) {
              // Live
              await this.$store.dispatch('sportsbook/getMarketsById', payload)
              // Clearing other tab's data to force API call for latest data
              this.$store.commit('sportsbook/set_data', {
                matchData: [],
                upComing: true
              })
              this.checkArtemisDataAvailable(this.liveMarkets?.fixtures)
            } else {
              // Upcoming
              await this.$store.dispatch('sportsbook/getMarketsById', {
                ...payload,
                upComing: true
              })
              // Clearing other tab's data to force API call for latest data
              this.$store.commit('sportsbook/set_data', {
                matchData: [],
                upComing: false
              })
              this.checkArtemisDataAvailable(this.upcomingMarkets?.fixtures, true)
            }
            // await this.joinSocket(upperFirst(this.categoryGame))
          } catch (error) {}
        }
      )
  
      const updateMatchStatusCallback = async () => {
        try {
          const payload = {
            game: upperFirst(this.categoryGame),
            userId,
            loading: false,
            gameName: this.$route.params.subCategory
          }
          if (this.tab === 0) {
            // Live
            await this.$store.dispatch('sportsbook/getMarketsById', payload)
            // Clearing other tab's data to force API call for latest data
            this.$store.commit('sportsbook/set_data', {
              matchData: [],
              upComing: true
            })
            this.checkArtemisDataAvailable(this.liveMarkets?.fixtures)
          } else {
            // Upcoming
            await this.$store.dispatch('sportsbook/getMarketsById', {
              ...payload,
              upComing: true
            })
            // Clearing other tab's data to force API call for latest data
            this.$store.commit('sportsbook/set_data', {
              matchData: [],
              upComing: false
            })
            this.checkArtemisDataAvailable(this.upcomingMarkets?.fixtures, true)
          }
          await this.joinSocket(upperFirst(this.$route.params.category))
        } catch (error) {}
      }
  
      socket.commonSocket.on(
        'updateMatchStatus_' + upperFirst(this.categoryGame),
        updateMatchStatusCallback
      )
      // Listening to 'Suspended' On/Off
      socket.commonSocket.on('updateMatchStatus', (data) => {
        if (data !== 'updated') updateMatchStatusCallback()
      })
      // Artemis Bookmaker
      if (
        this.checkUrlCategory() &&
        (!this.$auth.user || (this.$auth?.user && this.$auth.user.artemis))
      ) {
        this.getArthemisBookmaker(this.checkUrlCategory(), '', true)
        if (this.$auth.user && this.$auth.loggedIn) {
          this.getArthemisBookmakerBook(this.checkUrlCategory())
        }
        socket.commonSocket.on(
          'ArtemiseSocketAfterPlaceBets_' + this.$auth?.user?._id,
          (data) => {
            console.log('Data received:', data)
            this.$store.dispatch('betLoading/close')
            this.$store.commit('placeBet/reset_popover')
            this.$store.commit('betBooks/reset_newData')
            this.$store.commit('betBooks/reset_newPremiumData')
            this.$store.commit('betBooks/reset_newbookmakerData')
            const isDrawerOpen = localStorage.getItem('bottomBar')
              ? JSON.parse(localStorage.getItem('bottomBar'))
              : true
            this.$store.commit(
              'notificationMarquee/set_isBottomDrawerOpen',
              isDrawerOpen
            )
  
            if (
              data &&
              data.eventKey &&
              data.eventKey.includes('invalidateArtemise')
            ) {
              console.log('Body data', data.message)
              this.callinvalidate(data)
              // setTimeout(() => {
              //   this.closeDialogsOneByOne()
              // }, 30000) // 30 seconds
              this.$store.dispatch(
                'openBets/getMyCurrentBetStatusBookmakerMarket'
              )
              if (this.$auth.user && this.$auth.loggedIn && data.isBookmaker) {
                this.getArthemisBookmakerBook(
                  this.checkUrlCategory(),
                  this.betfairEventID,
                  false
                )
              }
            } else if (data && data.message && data.message.status === 200) {
              // console.log('Snackbar success:', data.message.message)
              // setTimeout(() => {
              this.$store.commit('snackbar/open', {
                text: data.message.message,
                color: 'success'
              })
  
              this.$store.dispatch(
                'openBets/getMyCurrentBetStatusBookmakerMarket'
              )
              if (this.$auth.user && this.$auth.loggedIn && data.isBookmaker) {
                this.getArthemisBookmakerBook(
                  this.checkUrlCategory(),
                  this.betfairEventID,
                  false
                )
              }
              // }, 2000)
            } else if (
              data &&
              data.message &&
              data.message.status === 400 &&
              data.message.success === false
            ) {
              // console.log('Snackbar error:', data.message.message)
              // setTimeout(() => {
              this.$store.commit('snackbar/open', {
                text: data.message.message,
                color: 'error'
              })
              this.$store.dispatch(
                'openBets/getMyCurrentBetStatusBookmakerMarket'
              )
              if (this.$auth.user && this.$auth.loggedIn && data.isBookmaker) {
                this.getArthemisBookmakerBook(
                  this.checkUrlCategory(),
                  this.betfairEventID,
                  false
                )
              }
              // }, 2000)
            } else {
              console.log('ArtemiseSocketAfterPlaceBets_ Unexpected data:', data)
            }
          }
        )
      }
    },
    async beforeDestroy() {
      this.clearOtherGameTabLocalStorage()
      this.cancelBtn()
      await this.leaveSocket()
      socket.commonSocket.off(
        'marketEnable_' + upperFirst(this.$route.params.category)
      )
      socket.commonSocket.off(
        'updateMatchStatus_' + upperFirst(this.$route.params.category)
      )
      if (this.$auth?.loggedIn) {
        socket.commonSocket.off(
          'ArtemiseSocketAfterPlaceBets_' + this.$auth?.user?._id
        )
      }
    },
    methods: {
      callinvalidate(data) {
        if (data && Object.keys(data).length > 0) {
          this.invalidBets.push(data)
          this.popupVisible = true
        }
      },
      closeDialog(index) {
        this.invalidBets.splice(index, 1)
      },
      closeDialogsOneByOne() {
        console.log('IN before close')
        const closeDialogInterval = setInterval(() => {
          if (this.invalidBets.length > 0) {
            console.log('IN inside close')
            const indexToClose = this.invalidBets.length - 1
            this.closeDialog(indexToClose)
          } else {
            clearInterval(closeDialogInterval)
          }
        }, 1000)
      },
      checkUrlCategory() {
        if (
          this.$route.params.category &&
          this.$route.params.category === 'horse-racing'
        ) {
          return 'Horse Racing'
        } else if (
          this.$route.params.category &&
          this.$route.params.category === 'greyhound-racing'
        ) {
          return 'Greyhound Racing'
        } else return this.$route.params.category
      },
      async getArthemisBookmakerBook(category, eventId) {
        if (category === 'Cricket' && this.$auth.user && this.$auth.loggedIn) {
          await this.$store.dispatch('betBooks/getAllBookmaker', {
            dataSet: eventId,
            refresh: this.refresh
          })
        }
      },
      async checkArtemisDataAvailable(currentMarketFixtures, upComing = false) {
        if (
          this.checkUrlCategory() === 'Cricket' &&
          (!this.$auth.user || (this.$auth?.user && this.$auth.user.artemis)) &&
          currentMarketFixtures?.length
        ) {
          const newCurrentMarketFixtures = [...currentMarketFixtures]
          const newEventID = []
          let newData = []
          for (let i = 0; i < currentMarketFixtures.length; i++) {
            if (
              currentMarketFixtures[i].betfairOdds &&
              currentMarketFixtures[i].betfairOdds === 'false' &&
              currentMarketFixtures[i].eventId
            ) {
              newData = await this.getArthemisBookmaker(
                '',
                currentMarketFixtures[i].eventId,
                true
              )
              if (newData && newData !== undefined && newData.eventName) {
                newCurrentMarketFixtures[i].artemisMatchOddsData = [newData]
                newEventID.push(currentMarketFixtures[i].eventId)
              }
            }
          }
          if (newData && newData !== undefined && newData.eventName) {
            await this.getArthemisBookmakerBook(
              this.$route.params.category,
              newEventID
            )
            this.$store.commit('sportsbook/set_data', {
              matchData: newCurrentMarketFixtures,
              upComing
            })
          }
          this.betfairEventID = newEventID
        }
      },
      async getArthemisBookmaker(socketData, betfairId, status) {
        if (betfairId) {
          const abc = await this.$store.dispatch('bookmakerMarket/get', {
            betfairId,
            socketData
          })
          if (status && abc && abc.length) {
            const findOut = abc.find((obj) => obj.name === 'Match Odds')
            if (findOut && findOut.name) {
              this.$store.dispatch('socketBookmakerMarket/joinRoomsBookmaker', {
                socketId: socket.commonSocket.id,
                gameName: 'Cricket',
                betfairId
              })
              this.$store.dispatch('socketBookmakerMarket/joinRoomsIndividual', {
                socketId: socket.commonSocket.id,
                gameName: 'Cricket',
                betfairId
              })
              return findOut
            }
          }
        }
      },
      async cancelBtn() {
        await this.$store.commit('placeBet/reset_popover')
        await this.$store.commit('betBooks/reset_newData')
        this.stake = ''
      },
      getMatchLink(id) {
        if (process.client && window) {
          return window.location.href + '/' + id
        } else {
          return ''
        }
      },
      async joinSocket(gameId) {
        await Promise.all([
          this.$store.dispatch('socketRate/joinRooms', socket.rateSocket.id),
          this.$store.dispatch(
            'socketRate/joinEventIDsRooms',
            socket.rateSocket.id
          ),
          this.$store.dispatch('socketBookmaker/joinRooms', socket.rateSocket.id),
          this.$store.dispatch('socketMain/joinRooms', {
            socketId: socket.commonSocket.id,
            gameId
          })
        ])
      },
      async leaveSocket() {
        await Promise.all([
          this.$store.dispatch('socketRate/leaveRooms'),
          this.$store.dispatch('socketRate/leaveEventIDsRooms'),
          this.$store.dispatch('socketBookmaker/leaveRooms'),
          this.$store.dispatch('socketMain/leaveRooms')
        ])
      },
      getTitle(category, fixture) {
        const fixturedate = this.$moment(fixture.marketStartTime)
        if (fixturedate.isAfter(this.$moment.date)) {
          if (this.$moment().isSame(this.$moment(fixturedate), 'week')) {
            return this.$moment(fixturedate).calendar()
            // return this.$moment(fixturedate).endOf('day').fromNow()
          } else {
            return this.$moment(fixturedate).format('llll')
            // return this.$moment(fixturedate).endOf('day').fromNow()
          }
        } else {
          this.dateShow = false
          return ''
        }
      },
      openAll(v) {
        if (v) return [...v.keys()].map((k, i) => i)
      },
      toKebabCase(inputString) {
        return inputString.replace(/ /g, '-').toLowerCase()
      },
      fromKebabToNormalCase(inputString) {
        return inputString
          .split('-') // Split by hyphens
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
          .join(' ') // Join words with spaces
      },
      async handleTabChange(source = null) {
        let userId
        if (this.$auth?.loggedIn) {
          userId = this.$auth?.user?._id
        }
        const payload = {
          game: upperFirst(this.categoryGame),
          userId,
          loading: true,
          gameName: this.$route.params.subCategory
        }
  
        switch (this.tab) {
          // Live
          case 0:
            if (this.liveMarkets?.fixtures?.length === 0) {
              await this.$store.dispatch('sportsbook/getMarketsById', payload)
              // Automatically switch to 'Upcoming' tab if No Live matches are present.
              if (source === 'init') {
                if (this.liveMarkets?.fixtures?.length === 0) {
                  this.tab = 1 // 'Upcoming' tab
                  this.handleTabChange()
                }
              }
              this.checkArtemisDataAvailable(this.liveMarkets?.fixtures)
            }
            if (this.$auth.loggedIn && this.liveMatchIds.length > 0) {
              this.$store.dispatch(
                'betBooks/getAll',
                this.liveMatchIds,
                this.refresh
              )
            }
            break
  
          // Upcoming
          case 1:
            if (this.upcomingMarkets?.fixtures?.length === 0) {
              await this.$store.dispatch('sportsbook/getMarketsById', {
                ...payload,
                upComing: true
              })
              this.checkArtemisDataAvailable(this.upcomingMarkets?.fixtures, true)
            }
            break
  
          // Leagues
          case 2:
            this.$store.dispatch(
              'sportsbookCategory/getCompetition',
              this.gameName
            )
            break
        }
        console.log('this.tab1----', this.tab, this.matchIds)
        if (this.$auth.loggedIn && this.matchIds && this.matchIds.length > 0) {
          this.$store.dispatch('betBooks/getAll', this.matchIds, this.refresh)
        }
        this.joinSocket(upperFirst(this.categoryGame))
      },
      clearOtherGameTabLocalStorage() {
        const gameList = [
          'Cricket',
          'Soccer',
          'Election',
          'Tennis',
          'Horse Racing',
          'Greyhound Racing'
        ]
        gameList.forEach((game) => {
          // Clearing all game tab index locatStorage other than the current one
          if (game !== this.gameName) {
            localStorage.removeItem(`activeTab_${game}`)
            localStorage.removeItem(`activeSubTab_${game}`)
          }
        })
      }
    }
  }
  </script>
  <style lang="scss" scoped>
  .listOdds {
    background-color: white;
    // border: 1px solid #fa7b04;
    border-top: 0;
    &:last-child {
      border-bottom-left-radius: 1rem !important;
      border-bottom-right-radius: 1rem !important;
    }
  }
  
  .sportsbook {
    // padding: 1rem;
  
    &.dark-theme {
      background: rgb(31, 31, 31);
      background: linear-gradient(
        180deg,
        rgba(31, 31, 31, 1) 35%,
        rgba(0, 0, 0, 1) 100%
      );
    }
  
    // border-radius: 1rem;
  }
  
  .border-radius {
    border-top-right-radius: 1.1rem !important;
    border-top-left-radius: 1.1rem !important;
    border-radius: 1.1rem !important;
  }
  
  .shadow-light {
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
      0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  }
  
  .v-expansion-panel-content__wrap {
    .v-card:last-child {
      border-bottom-left-radius: 1rem !important;
      border-bottom-right-radius: 1rem !important;
    }
  }
  </style>